/**
 * For catching ajax Response class from php.
 */
import { Response } from "@ex-online/commons";
import { getTagBrowserRootUrl } from "../core/core";
import TopN from "../notification/top-n";

export interface ResponseObject {
    status: string;
    message: string;
    data: any[];
    timestamp: number;
    err: any;
    "auto-close": any;
}

/**
 * Extension methods for response for client side UI controls
 */
export default class EXOResponse<T> extends Response<T> {
    /**
     * Show the corresponding popup given return JSON
     * EXOTopNotification.js must be loaded
     * @see EXOTopNotification
     *
     * @param autoClose
     * @param warning - Downgrades an 'Error' (danger) to a 'Warning', if true
     */
    public autoPopUp(autoClose = true, warning = false) {
        if (!this.body) {
            // Auto pop up shows internal error if return result is not valid response
            TopN.notifyDanger("Internal Error");
            return;
        }

        let mode = "danger";
        if (warning === true) {
            mode = "warning";
        }

        mode = this.getStatus() === "success" ? "success" : mode;
        mode = this.getStatus() === "warning" ? "warning" : mode;

        if (this.getStatus() === "logout") {
            setTimeout(
                () => {
                    window.location.replace(getTagBrowserRootUrl() + "User/Login");
                }, 4000);
        }
        TopN.showNotification(this.getMessage(), mode, autoClose);
    }

    /**
     * Get data of a given field or all
     * 
     * @param field
     * @return
     * 
     * @deprecated Use the generic type T `body` parameter as it provides better type hinting
     * @see body
     */
    public getData(field = "") {
        // data is string
        if (typeof this.body.data === "string") {
            return this.body.data;
        }

        // data is not string
        if (field) {
            // @ts-ignore This is deprecated in favor of the generic type T body
            return this.body.data[field];
        }
        return this.body.data;
    }
}

/**
 * Sugar method to save time
 * 
 * @param data
 * @param autoClose Will the popup auto close
 * @param warning Is the popup a warning
 */
export function autoPopUp<T>(
    data: any,
    autoClose = true,
    warning = false) {
    const obj = new EXOResponse<T>(data);
    obj.autoPopUp(autoClose, warning);
    return obj;
}
